export const CalendarIcon = (props) => (
  <svg fill="none" height={20} viewBox="0 0 20 20" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.2 4.3999H5.8C4.2536 4.3999 3 5.65351 3 7.1999V14.1999C3 15.7463 4.2536 16.9999 5.8 16.9999H14.2C15.7464 16.9999 17 15.7463 17 14.1999V7.1999C17 5.65351 15.7464 4.3999 14.2 4.3999Z"
      stroke={props.stroke ? props.stroke : "#667085"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
    <path
      d="M7.2 2.99988V5.79988M12.8 2.99988V5.79988M3 8.59988H17"
      stroke={props.stroke ? props.stroke : "#667085"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);
